
// import React from "react";
// import { X, ChevronRight } from "lucide-react";

// // Helper to determine file icon styles based on extension
// const getFileIconProps = (fileName) => {
//   if (!fileName) return { bg: "bg-gray-400", label: "FILE" };
//   const ext = fileName.split('.').pop().toLowerCase();
  
//   if (ext === 'pdf') return { bg: "bg-[#E5252A]", label: "PDF" };
//   if (ext === 'docx' || ext === 'doc') return { bg: "bg-[#2B579A]", label: "DOC" };
//   if (ext === 'xlsx' || ext === 'xls' || ext === 'csv') return { bg: "bg-[#217346]", label: "XLS" };
  
//   return { bg: "bg-gray-400", label: "FILE" };
// };

// const SourcesListModal = ({ isOpen, onClose, sources, onSelectSource }) => {
//   if (!isOpen) return null;

//   return (
//     <>
//       <style>
//         {`
//           @keyframes slideInRight {
//             from { transform: translateX(100%); }
//             to { transform: translateX(0); }
//           }
//         `}
//       </style>
//       <div className="fixed inset-0 z-[9998] flex justify-end font-outfit">
        
//         {/* Backdrop */}
//         <div 
//           className="absolute inset-0 bg-black/40 backdrop-blur-[2px] transition-opacity" 
//           onClick={onClose} 
//         />
        
//         {/* Sliding Panel */}
//         <div 
//           className="relative w-full max-w-[550px] h-full bg-white shadow-2xl flex flex-col"
//           style={{ animation: 'slideInRight 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards' }}
//         >
//           {/* Header */}
//           <div className="flex items-center justify-between px-6 py-3 border-b border-gray-100 bg-white">
//             <h2 className="text-[18px] font-medium text-[#18101C]">
//               Referenced Sources ({sources?.length || 0})
//             </h2>
//             <button 
//               onClick={onClose} 
//               className="p-1.5 hover:bg-gray-100 rounded-full transition-colors text-gray-500"
//             >
//               <X className="w-5 h-5" />
//             </button>
//           </div>
          
//           {/* Source List */}
//           <div className="flex-1 overflow-y-auto p-6 space-y-2 custom-scrollbar bg-[#FCFCFC]">
//             {sources && sources.length > 0 ? (
//               sources.map((source, idx) => {
//                 // Extract values supporting both old (analyze/) and new (section-view/) API formats
//                 const pageNumber = source.page_number !== undefined ? source.page_number : source.page;
//                 const snippetText = source.source_chunk || source.snippet || "";
//                 const fileProps = getFileIconProps(source.file_name);
                
//                 // Determine if it should say "Sheet" (Excel) or "Page" (PDF/Word)
//                 const isExcel = source.file_name?.toLowerCase().match(/\.(xlsx|xls|csv)$/);
//                 const locationLabel = isExcel ? 'Sheet' : 'Page';

//                 return (
//                   <div 
//                     key={idx} 
//                     onClick={() => onSelectSource(source)}
//                     className="p-3 border border-gray-200 rounded-[8px] hover:border-[#BB42AE] hover:shadow-sm transition-all cursor-pointer bg-white flex items-center justify-between group"
//                   >
//                     <div className="flex-1 min-w-0 pr-4">
                      
//                       {/* Top row: Icon, Filename, Page */}
//                       <div className="flex items-center gap-2.5 mb-2">
//                         <div className={`w-5 h-5 rounded-[4px] flex items-center justify-center text-[8px] font-bold text-white shrink-0 ${fileProps.bg}`}>
//                           {fileProps.label}
//                         </div>
//                         <h4 className="text-[14px] font-medium text-[#18101C] truncate">
//                           {source.file_name || "Unknown Document"}
//                         </h4>
                        
//                         {pageNumber !== undefined && pageNumber !== null && (
//                           <>
//                             <span className="text-gray-300 font-light">|</span>
//                             <span className="text-[13px] text-gray-500 whitespace-nowrap">
//                               {locationLabel} {pageNumber}
//                             </span>
//                           </>
//                         )}
//                       </div>
                      
//                       {/* Snippet */}
//                       <p className="text-[13px] text-gray-500 italic line-clamp-2 leading-relaxed ml-[30px]">
//                         "{snippetText}"
//                       </p>
//                     </div>
                    
//                     {/* Right Arrow */}
//                     <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-[#BB42AE] shrink-0 transition-colors" />
//                   </div>
//                 );
//               })
//             ) : (
//               <div className="text-center py-12">
//                 <p className="text-gray-500 text-[15px]">No sources available for this content.</p>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default SourcesListModal;
import React from "react";
import { X, ChevronRight } from "lucide-react";

// Helper to determine file icon styles based on extension
const getFileIconProps = (fileName) => {
  if (!fileName) return { bg: "bg-gray-400", label: "FILE" };
  const ext = fileName.split('.').pop().toLowerCase();
  
  if (ext === 'pdf') return { bg: "bg-[#E5252A]", label: "PDF" };
  if (ext === 'docx' || ext === 'doc') return { bg: "bg-[#2B579A]", label: "DOC" };
  if (ext === 'xlsx' || ext === 'xls' || ext === 'csv') return { bg: "bg-[#217346]", label: "XLS" };
  
  return { bg: "bg-gray-400", label: "FILE" };
};

const SourcesListModal = ({ isOpen, onClose, sources, onSelectSource }) => {
  if (!isOpen) return null;

  return (
    <>
      <style>
        {`
          @keyframes slideInRight {
            from { transform: translateX(100%); }
            to { transform: translateX(0); }
          }
        `}
      </style>
      <div className="fixed inset-0 z-[9998] flex justify-end font-outfit">
        
        {/* Backdrop */}
        <div 
          className="absolute inset-0 bg-black/40 backdrop-blur-[2px] transition-opacity" 
          onClick={onClose} 
        />
        
        {/* Sliding Panel */}
        <div 
          className="relative w-full max-w-[550px] h-full bg-white shadow-2xl flex flex-col"
          style={{ animation: 'slideInRight 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards' }}
        >
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-3 border-b border-gray-100 bg-white">
            <h2 className="text-[18px] font-medium text-[#18101C]">
              Referenced Sources ({sources?.length || 0})
            </h2>
            <button 
              onClick={onClose} 
              className="p-1.5 hover:bg-gray-100 rounded-full transition-colors text-gray-500"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
          
          {/* Source List */}
          <div className="flex-1 overflow-y-auto p-6 space-y-2 custom-scrollbar bg-[#FCFCFC]">
            {sources && sources.length > 0 ? (
              sources.map((source, idx) => {
                // FIXED: Support both API structures safely
                const pageNumber = source.page_number !== undefined ? source.page_number : source.page;
                const snippetText = source.source_chunk || source.snippet || "";
                const fileName = source.file_name || source.document_name || "Unknown Document";
                const fileProps = getFileIconProps(fileName);
                
                // Determine if it should say "Sheet" (Excel) or "Page" (PDF/Word)
                const isExcel = fileName?.toLowerCase().match(/\.(xlsx|xls|csv)$/);
                const locationLabel = isExcel ? 'Sheet' : 'Page';

                return (
                  <div 
                    key={idx} 
                    // FIXED: Pass the raw source object exactly as it is, no modification
                    onClick={() => onSelectSource(source)}
                    className="p-3 border border-gray-200 rounded-[8px] hover:border-[#BB42AE] hover:shadow-sm transition-all cursor-pointer bg-white flex items-center justify-between group"
                  >
                    <div className="flex-1 min-w-0 pr-4">
                      
                      {/* Top row: Icon, Filename, Page */}
                      <div className="flex items-center gap-2.5 mb-2">
                        <div className={`w-5 h-5 rounded-[4px] flex items-center justify-center text-[8px] font-bold text-white shrink-0 ${fileProps.bg}`}>
                          {fileProps.label}
                        </div>
                        <h4 className="text-[14px] font-medium text-[#18101C] truncate">
                          {fileName}
                        </h4>
                        
                        {pageNumber !== undefined && pageNumber !== null && pageNumber !== "Unknown" && (
                          <>
                            <span className="text-gray-300 font-light">|</span>
                            <span className="text-[13px] text-gray-500 whitespace-nowrap">
                              {locationLabel} {pageNumber}
                            </span>
                          </>
                        )}
                      </div>
                      
                      {/* Snippet */}
                      <p className="text-[13px] text-gray-500 italic line-clamp-2 leading-relaxed ml-[30px]">
                        "{snippetText}"
                      </p>
                    </div>
                    
                    {/* Right Arrow */}
                    <ChevronRight className="w-5 h-5 text-gray-400 group-hover:text-[#BB42AE] shrink-0 transition-colors" />
                  </div>
                );
              })
            ) : (
              <div className="text-center py-12">
                <p className="text-gray-500 text-[15px]">No sources available for this content.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SourcesListModal;
